module.exports = __FOREMAN_VENDOR__NOVNC_NOVNC_CORE_RFB__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__NOVNC_NOVNC_CORE_RFB__"
// module id = @novnc/novnc/core/rfb
// module chunks = 0